// store/notificationSlice.js
import { createSlice } from "@reduxjs/toolkit";

const notificationSlice = createSlice({
  name: "notification",
  initialState: {
    permission: Notification.permission || "default",
  },
  reducers: {
    setPermission: (state, action) => {
      state.permission = action.payload;
    },
  },
});

export const { setPermission } = notificationSlice.actions;
export default notificationSlice.reducer;
